import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { Link } from "react-router-dom";
import axios from "axios";
import Authorize from "../../../global/Authorize";
import Skeleton from "react-loading-skeleton";
import { connect } from "react-redux";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class AddMarks extends Component {
  state = {
    fakeData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    loading: true,
    currentTab: 0,
    classData: [],
    date: `${new Date().getFullYear()}-${
      (new Date().getMonth() + 1 < 10 ? "0" : "") + (new Date().getMonth() + 1)
    }-${(new Date().getDate() < 10 ? "0" : "") + new Date().getDate()}`,
  };
  componentDidMount = () => {
    this.fetchClass();
  };
  fetchClass = () => {
    axios
      .get("/api/class")
      .then((res) => {
        this.setState({ classData: res.data, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  render() {
    let { classData } = this.state;

    let unrestrictedRoles = ["IS_SUPERADMIN", "IS_PRINCIPAL", "IS_ACCOUNTANT"];
    let assignedClassSubject = JSON.parse(
      localStorage.getItem("assignedClassSubject")
    );

    let assignedClass = assignedClassSubject?.mapping_data?.map(
      (each) => each.assign_class_id
    );

    let assignedClassList = unrestrictedRoles?.includes(
      this.props.user.role.name
    )
      ? classData
      : classData?.filter((each) => assignedClass?.includes(each.id));

    return (
      <Authorize
        roles={["IS_TEACHER", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/"
      >
        <Header to="/home" title="Add Marks" />
        <div>
          {/* Layout Rendered */}
          <div className="container">
            {this.state.loading ? (
              <div className="d-flex flex-wrap">
                {this.state.fakeData?.map((item, index) => {
                  return (
                    <div key={index} className="col-6 px-1">
                      <div className="btn mt-2 border rounded btn-block p-1">
                        <Skeleton />
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}

            {assignedClassList !== 0 && this.state.loading === false ? (
              <div className="d-flex flex-wrap">
                {assignedClassList?.map((classs) =>
                  classs.section?.map((section) => (
                    <div className="col-6 px-1">
                      <Link
                        type="button"
                        className="btn mt-2 th-att-btn btn-block"
                        to={`/addmarkstype/${classs.id}/${classs.class_name}/${section.id}/${section.section_name}`}
                      >
                        {classs.class_name} | {section.section_name}
                      </Link>
                    </div>
                  ))
                )}
              </div>
            ) : null}
          </div>
          {/* Layout Rendered ends*/}
        </div>
      </Authorize>
    );
  }
}
export default connect(mapStateToProps)(AddMarks);
